'use strict';
import { ready } from "./ready.js";
import { processPosts } from "./processPosts.js";

ready(function(){
  processPosts();
});
